import React from 'react';
import { Flex, Box } from 'rebass';
import Select from './../common/FormComponents/SelectMinimal';
import { colors } from '../../tailwind';

const defaultPublishOption = {
  value: 'all',
  label: 'All Listings',
};

const publishOptions = [
  defaultPublishOption,
  {
    value: 'published',
    label: 'Published',
  },
  {
    value: 'unpublished',
    label: 'Unpublished',
  },
];

const defaultSortOption = {
  value: 'recent',
  label: 'Recent',
};

const sortOptions = [
  defaultSortOption,
  {
    value: 'created',
    label: 'Date Created',
  },
  {
    value: 'price-low',
    label: 'Price (Low-High)',
  },
  {
    value: 'price-high',
    label: 'Price (High-Low)',
  },
];

export default class ManageListingsHeader extends React.Component {
  state = {
    selectedPublishFilter: defaultPublishOption,
    selectedSort: defaultSortOption,
    selectedLayout: 'list',
  };

  pickList = () => {
    const { layoutChanged } = this.props;
    this.setState({
      selectedLayout: 'list',
    });
    layoutChanged && layoutChanged('list');
  };

  pickSmall = () => {
    const { layoutChanged } = this.props;
    this.setState({
      selectedLayout: 'small',
    });
    layoutChanged && layoutChanged('small');
  };

  pickLarge = () => {
    const { layoutChanged } = this.props;
    this.setState({
      selectedLayout: 'large',
    });
    layoutChanged && layoutChanged('large');
  };

  render() {
    const { publishChanged, sortChanged } = this.props;
    return (
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
        alignItems="center"
      >
        <Flex>
          {' '}
          <Select
            defaultValue={defaultPublishOption}
            onChange={selectedPublishFilter => {
              this.setState({ selectedPublishFilter });
              publishChanged && publishChanged(selectedPublishFilter.value);
            }}
            options={publishOptions}
          />
        </Flex>
        <Box flex={1} />
        <Flex justifyContent="space-between" alignItems="center">
          {/* <Box ml={3} mr={3} onClick={this.pickList}>
            <i
              className="fa fa-th-list fa-lg"
              style={{
                color:
                  this.state.selectedLayout === 'list'
                    ? colors.primaryDark
                    : colors.grayDark,
              }}
            />
            </Box> */}
          <Box ml={3} mr={3} onClick={this.pickLarge}>
            <i
              className="fa fa-th-large fa-lg"
              style={{
                color:
                  this.state.selectedLayout === 'large'
                    ? colors.primaryDark
                    : colors.grayDark,
              }}
            />
          </Box>
          <Box ml={3} onClick={this.pickSmall}>
            <i
              className="fa fa-th fa-lg"
              style={{
                color:
                  this.state.selectedLayout === 'small'
                    ? colors.primaryDark
                    : colors.grayDark,
              }}
            />
          </Box>{' '}
          <Select
            defaultValue={defaultSortOption}
            onChange={selectedSort => {
              this.setState({ selectedSort });
              sortChanged && sortChanged(selectedSort.value);
            }}
            options={sortOptions}
          />
        </Flex>
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_new/managelisting/ManageListingsHeader.js